export default __webpack_public_path__ + "static/media/BB Logo.d7fdf98e.png";